export function translateY(px: string) {
  return {
    translateY: px,
  };
}
